import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";

const LoadSVG = ({ id}) => {
   
     const {
        CBLoadList,
    loadSelectHandler,
   count,
  } = useContext(DesignAssetContext);
   const areAllConfigured = () =>{
    const loadList = CBLoadList.filter(load => !load.uiData.isRemoteLoad);
    return loadList.every(item => item.uiData.configured);
  }
  const totalCount =
    typeof count === "object" && count !== null ? count.loadCount : loadLength || 0;
 
  return (
   <g id={id}>
              <svg
                x={558}
                y={380}
                width="149px"
                height="475px"
                viewBox="0 0 90 550"
                onClick={loadSelectHandler}
              >
                <title>load</title>
                <g
                  id="Design"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Design/Assets-_-00"
                    transform="translate(-604.000000, -372.000000)"
                  >
                    <g
                      id="SLD/Production/Uniline/Undefined"
                      transform="translate(604.000000, 372.000000)"
                    >
                      <g id="SLD/Production/Uniline/Tobedefine">
                        <g id="Group-7">
                          <rect
                            id="Rectangle"
                            x="0"
                            y="95"
                            width="96"
                            height="148"
                          ></rect>

                          <line
                            x1="48.5"
                            y1={"95"}
                            x2="48.5"
                            y2="144"
                            id="Line-2"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={areAllConfigured() ? "var(--se-sld-circline)" : "#E47F00"}
                          ></line>

                          <circle
                            id="Oval"
                            stroke={areAllConfigured() ? "var(--se-sld-circline)" : "#E47F00"}
                            strokeWidth="3"
                            cx="58"
                            cy="193.5"
                            r="45"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></circle>

                          <circle
                            id="Oval"
                            strokeWidth="3"
                            fill="var(--se-background-alternative)"
                            cx="48"
                            cy="193.5"
                            r="46.5"
                            stroke={areAllConfigured() ? "var(--se-sld-circline)" : "#E47F00"}
                          ></circle>

                          <text
                            id="segment_energy_infra"
                            fontFamily="se-icon"
                            fontSize="56"
                            fontWeight="normal"
                            fill="var(--se-sld-circline)"
                          >
                            <tspan x="20" y="210">
                              segment_building_small
                            </tspan>
                          </text>
                        </g>
                      </g>
                      <g
                        id="999🔒Atoms/Notifications/Done"
                        transform="translate(75.000000, 160.000000)"
                      >
                        <g
                          id="999🔒Atoms/Background/Round"
                          strokeWidth="1"
                          fillRule="evenodd"
                          fill={areAllConfigured() ? "var(--se-sld-circline)" : "#E47F00"}
                          stroke="var(--se-background-alternative)"
                        >
                          <circle
                            id="Oval"
                            strokeWidth="2.66666667"
                            cx="16"
                            cy="16"
                            r={count?.loadCount > 9 ? "20" : "18"}
                          ></circle>
                        </g>

                        <text
                          id="3"
                          fontFamily="Nunito-Regular, Nunito"
                          fontSize="21"
                          fontWeight="normal"
                          fill="var(--se-background-alternative)"
                        >
                          <tspan
                            x={count?.loadCount < 10 ? "8" : "5"}
                            y="24"
                          >
                            {totalCount}
                          </tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
    );
};

export default LoadSVG;